import { PlatformSlug } from 'constants/consts'
import { getFeatureConfig, isFeatureAvailable } from 'platformConfig'
import { isCrashCoursesAvailable } from 'pagesNew/CrashCourses/platformConfig'
import { isFullMiniTestsAvailable } from 'pagesNew/FullLengthTests/platformConfig'
import { isInfluencerHubAvailable } from 'pagesNew/InfluencerHub/platformConfig'
import { isPluginAvailable } from 'pagesNew/CARSPlugin/platformConfig'
import { FaqPages } from '__generatedTypes__/globalTypes'

export type FaqConfig = {
  homepage: boolean
  upgradePage: boolean
  fltPtAnalytics: boolean
  classroom: boolean
  accountSettings: boolean
  mcatScoreCalculation: boolean
  cheatSheetPreLaunch: boolean
}

const STANDARD_FAQ: FaqConfig = {
  homepage: true,
  upgradePage: true,
  fltPtAnalytics: false,
  classroom: true,
  accountSettings: true,
  mcatScoreCalculation: false,
  cheatSheetPreLaunch: false,
}

export const FAQ_CONFIG: Partial<Record<PlatformSlug, FaqConfig>> = {
  [PlatformSlug.DATBooster]: { ...STANDARD_FAQ, fltPtAnalytics: true },
  [PlatformSlug.OATBooster]: { ...STANDARD_FAQ, fltPtAnalytics: true },
  [PlatformSlug.DATCrusher]: { ...STANDARD_FAQ, fltPtAnalytics: true },
  [PlatformSlug.PATBooster]: { ...STANDARD_FAQ, fltPtAnalytics: true },
  [PlatformSlug.INBDEBooster]: { ...STANDARD_FAQ, fltPtAnalytics: true },
  [PlatformSlug.NBDHEBooster]: { ...STANDARD_FAQ, fltPtAnalytics: true },
  [PlatformSlug.NDEBCrusher]: STANDARD_FAQ,
  [PlatformSlug.CasperBooster]: STANDARD_FAQ,
  [PlatformSlug.CARSBooster]: STANDARD_FAQ,
  [PlatformSlug.GREBooster]: STANDARD_FAQ,
  [PlatformSlug.NBEOPartOne]: {
    ...STANDARD_FAQ,
    upgradePage: false,
    cheatSheetPreLaunch: true,
  },
  [PlatformSlug.DLOSCE]: STANDARD_FAQ,
  [PlatformSlug.MCATBooster]: {
    homepage: false,
    upgradePage: false,
    fltPtAnalytics: false,
    classroom: false,
    accountSettings: false,
    mcatScoreCalculation: true,
    cheatSheetPreLaunch: true,
  },
}

export const getFaqConfig = (slug?: PlatformSlug) => getFeatureConfig(FAQ_CONFIG, slug)
export const isFaqAvailable = (slug?: PlatformSlug) => isFeatureAvailable(FAQ_CONFIG, slug)

export const isFaqPageAvailable = (slug: PlatformSlug | undefined, page: FaqPages) => {
  const config = getFaqConfig(slug)
  if (!config || !slug) {
    return false
  }

  switch (page) {
    case FaqPages.HomePage:
      return config.homepage
    case FaqPages.UpgradePage:
      return config.upgradePage
    case FaqPages.AAMCPlugin:
    case FaqPages.AAMCPluginHowToUse:
      return isPluginAvailable(slug)
    case FaqPages.CrashCourses:
      return isCrashCoursesAvailable(slug)
    case FaqPages.FullTests:
      return isFullMiniTestsAvailable(slug)
    case FaqPages.PracticeTestAnalytics:
      return config.fltPtAnalytics
    case FaqPages.Classroom:
      return config.classroom
    case FaqPages.AccountSettings:
      return config.accountSettings
    case FaqPages.InfluencerHub:
      return isInfluencerHubAvailable(slug)
    case FaqPages.MCATScoreCalculation:
      return config.mcatScoreCalculation
    case FaqPages.CheatSheetPreLaunch:
      return config.cheatSheetPreLaunch
    default:
      return false
  }
}
